// extracted by mini-css-extract-plugin
export var orderSummary = "_rk-0";
export var showMoreLessButton = "_rk-1";